export default __webpack_public_path__ + "static/2-b97aa737f472875c8a5c5fa7769036a3.png";